import { memo, useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import { ToggleSwitcher, Text, Icon, AdvancedTooltip } from 'common-components'
import InfoIcon from 'assets/svgr-icons/Info.svg'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'
import { userSelectors } from 'store/features/user/selectors'
import { dispatch } from 'store'
import { useOpenUpgradePopup } from 'hooks/useOpenUpgradePopup'
import { REF_LINKS } from 'consts/refLinks'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import * as Styled from './styled'

const PowerMode = () => {
  const isSupported = useSelector(aiVideoSelectors.isFastTrackSupported)
  const isFastTrackActive = useSelector(aiVideoSelectors.isFastTrackActive)
  const isFreeUser = useSelector(userSelectors.isFreeUser)
  const openUpgradePopup = useOpenUpgradePopup()
  const [iconRef, setIconRef] = useState<HTMLDivElement | null>(null)

  const onChange = useCallback(() => {
    // Power mode is a paid feature: free users trying to enable it get the upgrade flow.
    if (!isFastTrackActive && isFreeUser) {
      openUpgradePopup({ ref: REF_LINKS.V_EDITOR_AI_VIDEO_GENERATE })
      return
    }
    dispatch(aiVideoThunks.setIsFastTrack(!isFastTrackActive))
  }, [isFreeUser, openUpgradePopup, isFastTrackActive])

  if (!isSupported) return null

  return (
    <Styled.PowerModeRow>
      <Styled.LabelGroup>
        <Text type="h2" fontWeight="600" color="secondaryDark">
          {translate(T.POWER_MODE_LABEL)}
        </Text>
        <Styled.IconAnchor ref={setIconRef}>
          <Icon icon={<InfoIcon />} size="medium" color="secondarySemiLight" />
        </Styled.IconAnchor>
        <AdvancedTooltip
          btnRef={{ current: iconRef }}
          tooltipText={translate(T.POWER_MODE_TOOLTIP)}
          tooltipPosition="top"
          showMobileTooltip
          textAlign="center"
        />
      </Styled.LabelGroup>
      <ToggleSwitcher isChecked={isFastTrackActive} onChange={onChange} />
    </Styled.PowerModeRow>
  )
}

export default memo(PowerMode)
